import React from "react";
import { connect } from "react-redux";
import { QuestionViewDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import moment from "moment";
import { IMG_PATH } from "utils/constants/imgPath";
import * as XLSX from "xlsx";
import { Displays, Tables, Inputs } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class QuestionViewDetailContainer extends React.Component {
  state = {
    isLoading: true,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (queryString) => {
    let resArr = await Promise.all([
      portalService.GET_QUESTION_DETAIL(this.props.router.params.id),
      portalService.GET_ASSESSMENT_BY_QUESTION_ADMIN_LIST(
        this.props.router.params.id,
        queryString
      ),
    ]);
    if (resArr) {
      this.setState({
        data: resArr[0].data,
        assessmentdata: resArr[1].data,
        pagination: {
          last_page: resArr[1].data.totalPages,
          current_page: resArr[1].data.page,
          total: resArr[1].data.totalDocs,
          per_page: resArr[1].data.limit,
        },
        isLoading: false,
        isBgLoading: false,
        isLoadingTable: false,
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoadingTable: true,
    });
    this.props.router.navigate(
      `${this.props.router.location.pathname}${joinQuery}`,
    );
    this.fetchData(joinQuery);
  };

  handleExport = async (permission) => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_ASSESSMENT_BY_QUESTION_ADMIN_LIST(
      this.props.router.params.id,
      joinQuery
    );
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";
      /* make worksheet */
      let ws_data = res.data.docs.reduce((result, e, i) => {
        let params = [
          i + 1,
          e.question_title,
          e.member_type === "1"
            ? `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: e.member_detail.first_name,
                action: "export",
              })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: e.member_detail.last_name,
                action: "export",
              })}`
            : RENDER_CHARACTER_REPLACE_BY_PERMISSION({
                ...permission,
                inputString: e.organization_detail.name,
                action: "export",
              }),
          RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: e.member_detail?.phone_number,
            type: "phone",
          }),
        ];
        if (e.question_list && e.question_list.length > 0) {
          e.question_list.forEach((f) => {
            if (f.type === "3") {
              if (f.answer) {
                params.push(IMG_PATH + f.answer);
              } else {
                params.push("-");
              }
            } else {
              params.push(f.answer);
            }
          });
        }
        result.push(params);
        return result;
      }, []);

      ws_data.splice(0, 0, [
        "No",
        "Form name",
        "Name",
        "Phone",
        ...(res.data.docs && res.data.docs.length > 0
          ? res.data.docs[0].question_list.map((e, i) => `Ans${i + 1}`)
          : []),
      ]);
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let wscols = [
        { wch: 5 },
        { wch: 15 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
        { wch: 20 },
      ];
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `booking-report-${moment()
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY")}.xlsx`
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  render() {
    const { authenRedux } = this.props;
    const {
      isLoading,
      isLoadingTable,
      isBgLoading,
      data,
      assessmentdata,
      pagination,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "question");
    return (
      <QuestionViewDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="block_section">
              <div className="title">ข้อมูลฟอร์มคำถาม</div>
              <div className="body">
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"ชื่อแบบสอบถาม"}
                    value={`${data.title}`}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"รายละเอียด"}
                    value={data.description}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    label={"คะแนน"}
                    value={`${data.point}`}
                  />
                </div>
              </div>
            </div>
            <div className="block_section">
              <div className="title">คำถาม</div>
              <div className="body pl_1">
                {data.question_list &&
                  data.question_list.map((e, i) => (
                    <div key={i} className="question_row">
                      <div className="question_label">
                        {`ข้อที่ ${i + 1} `}
                        {e.question}
                      </div>
                      <div className="question_ans_block">
                        {e.answer_list.map((f, j) => (
                          <div key={j} className="ans_label">
                            {`ตอบ ${j + 1} `}
                            {f}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="filter_wrap">
              <Inputs.InputFilter
                theme_standard_input_filter
                dataFilter={[]}
                btnLabel="ค้นหา"
                onQueryFilter={this.handleFilterKeyword}
                onExport={
                  permission &&
                  (permission.is_export || permission.is_export_condition)
                    ? () => this.handleExport(permission)
                    : false
                }
              />
            </div>
            {isLoadingTable ? (
              <Displays.Loading theme_standard_loading />
            ) : (
              <div className="body_table">
                <Tables.Standard
                  columns={columns({
                    permission: permission,
                    data: data,
                    // handleClickGifgPoint: this.handleClickGifgPoint,
                  })}
                  data={assessmentdata.docs}
                  showPagination
                  pagination={pagination}
                  handlePageClick={this.handlePageClick}
                  onChangePerPage={this.handlePerPageChange}
                />
              </div>
            )}
          </>
        )}
      </QuestionViewDetailContainerStyled>
    );
  }
}

// const dataFilter = [
//   {
//     accessor: 'activity_code',
//     length: '311px',
//     filter: {
//       fieldQuery: 'activity_code',
//       type: 'text',
//       label: 'Activity Code',
//       placeholder: 'Activity Code',
//     },
//   },
// ];

const columns = ({ permission, data }) => {
  let params = [
    {
      Header: <div style={{ textAlign: "left" }}>Form name</div>,
      accessor: "question_title",
      Cell: (props) => <div>{`${props.value}`}</div>,
    },
    {
      Header: <div style={{ textAlign: "left" }}>Name</div>,
      accessor: "member_detail.first_name",
      Cell: (props) =>
        props.row.original.member_type === "2" ? (
          RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: props.row.original.organization_detail.name,
          })
        ) : (
          <div>
            {`${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: props.value,
            })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: props.row.original.member_detail.last_name,
            })}`}
          </div>
        ),
    },
    {
      Header: <div style={{ textAlign: "left" }}>Phone</div>,
      accessor: "member_detail.phone_number",
      Cell: (props) =>
        props.row.original.member_type === "2" ? (
          RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: props.row.original.organization_detail.phone_number,
          })
        ) : (
          <div>{`${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: props.value,
            type: "phone",
          })}`}</div>
        ),
    },
  ];
  if (data.question_list && data.question_list.length > 0) {
    data.question_list.forEach((e, i) => {
      params.push({
        Header: <div style={{ textAlign: "left" }}>{`Ans${i + 1}`}</div>,
        accessor: `question_list${i + 1}`,
        Cell: (props) => (
          <div>{props.row.original.question_list[i].answer}</div>
        ),
      });
    });
  }
  return params;
};

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(QuestionViewDetailContainer));
